<template>
  <div>
    <v-speed-dial fab fixed bottom right v-model="fab">
      <v-btn dark fab slot="activator" class="secondary" v-model="fab">
        <v-icon>edit</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
      <v-btn fab dark small class="primary" v-tooltip:left="{ html: 'Pagamentos' }" :to="({ name: 'ImoveisDetalhesPagamentos', params: { id: $route.params.id } })" v-if="$hasGranularPermission('pagamentos', 'view')">
        <v-icon>account_balance_wallet</v-icon>
      </v-btn>
      <v-btn fab dark small class="primary" v-tooltip:left="{ html: 'Vistoria' }" @click.native.stop="substituirVistoria()" v-if="showVistoriaButton">
        <v-icon>schedule</v-icon>
      </v-btn>
      <v-btn fab dark small class="primary" v-tooltip:left="{ html: 'Tarefas' }" :to="({ name: 'TarefasLista', params: { id: $route.params.id } })" v-if="showTarefasButton">
        <v-icon>event_available</v-icon>
      </v-btn>
      <v-btn fab dark small class="primary" v-tooltip:left="{ html: 'Info' }" :to="({ name: 'ImoveisDetalhesInfo', params: { id: $route.params.id } })" v-if="$hasGranularPermission('info', 'view')">
        <v-icon>info_outline</v-icon>
      </v-btn>
      <v-btn fab dark small class="primary" v-tooltip:left="{ html: 'Fotos de apresentação' }" :to="({ name: 'ImoveisDetalhesFotos', params: { tipo: 'ilustrativa', id: $route.params.id } })" v-if="$hasGranularPermission('fotos', 'view')">
        <v-icon>photo_library</v-icon>
      </v-btn>
      <v-btn fab dark small class="grey" v-tooltip:left="{ html: 'Endereço' }" :to="({ name: 'ImoveisDetalhesEndereco', params: { id: $route.params.id } })" v-if="$hasGranularPermission('endereco', 'view')">
        <v-icon>room</v-icon>
      </v-btn>
      <v-btn fab dark small class="grey" v-tooltip:left="{ html: 'Registros / documentos' }" :to="({ name: 'ImoveisDetalhesRegistro', params: { id: $route.params.id } })" v-if="$hasGranularPermission('registro', 'view')">
        <v-icon>description</v-icon>
      </v-btn>
      <v-btn fab dark small class="grey" v-tooltip:left="{ html: 'Área' }" :to="({ name: 'ImoveisDetalhesArea', params: { id: $route.params.id } })" v-if="$hasGranularPermission('area', 'view')">
        <v-icon>filter_hdr</v-icon>
      </v-btn>
      <v-btn fab dark small class="grey" v-tooltip:left="{ html: 'IPTU / impostos / taxas' }" :to="({ name: 'ImoveisDetalhesTaxas', params: { id: $route.params.id } })" v-if="$hasGranularPermission('taxas', 'view')">
        <v-icon>location_city</v-icon>
      </v-btn>
      <v-btn fab dark small class="grey" v-tooltip:left="{ html: 'Valor' }" :to="({ name: 'ImoveisDetalhesValor', params: { id: $route.params.id } })" v-if="$hasGranularPermission('valor', 'view')">
        <v-icon>local_atm</v-icon>
      </v-btn>
      <v-btn fab dark small class="grey" v-tooltip:left="{ html: 'Status' }" :to="({ name: 'ImoveisDetalhesStatus', params: { id: $route.params.id } })" v-if="$hasGranularPermission('status', 'view')">
        <v-icon>check_circle</v-icon>
      </v-btn>
      <v-btn fab dark small class="secondary" v-tooltip:left="{ html: 'Baixar PDF' }" @click.native="$parent.download()">
        <v-icon>mdi-file-pdf</v-icon>
      </v-btn>
    </v-speed-dial>
    <transition name="fade-transition">
      <div class="fab-background" v-show="fab"></div>
    </transition>
    <v-dialog v-model="dialogSubstituirVistoria" max-width="620">
      <v-card class="botoes_com_padding_menor">
        <v-card-title class="headline">Substituir ou editar vistoria?</v-card-title>
        <v-card-text><strong>ATENÇÃO:</strong> A vistoria atual será removida caso você escolha a opção substituir.</v-card-text>
        <v-card-actions>
          <v-btn class="primary--text darken-1" flat="flat" @click.native="dialogSubstituirVistoria = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" :to="({ name: 'VistoriaEditar', params: { id: $route.params.id } })">Editar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" :to="({ name: 'VistoriaAdicionar', params: { id: $route.params.id } })">Substituir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        fab: false,
        dialogSubstituirVistoria: false
      }
    },
    mounted () {
      this.$primeUserRestrictions()
    },
    props: ['status'],
    computed: {
      currentUser () {
        if (!this.$auth || typeof this.$auth.user !== 'function') return null
        return this.$auth.user()
      },
      isLimitadoTarefas () {
        return this.$hasUserRestrictionFlag('limitado_tarefas')
      },
      showVistoriaButton () {
        return !this.isLimitadoTarefas && this.$hasGranularPermission('vistoria', 'add')
      },
      showTarefasButton () {
        return !this.isLimitadoTarefas && this.$hasGranularPermission('tarefas', 'add')
      }
    },
    methods: {
      substituirVistoria (event) {
        const imovel = this.$store.getters['imoveis/detalhes']

        if (imovel.hasOwnProperty('vistoria')) {
          this.fab = false
          this.dialogSubstituirVistoria = true
        } else {
          this.$router.push({ name: 'VistoriaAdicionar', params: { id: this.$route.params.id } })
        }
      }
    }
  }
</script>

<style scoped>
  .speed-dial { z-index: 200; }
  .speed-dial [data-tooltip][data-tooltip-location='left']:before {  background: none; color: #000000; box-shadow: none; font-size: 13px; opacity: 1; -moz-transform: translate3d(0, 0, 0) scale(1); -webkit-transform: translate3d(0, 0, 0) scale(1); -o-transform: translate3d(0, 0, 0) scale(1); -ms-transform: translate3d(0, 0, 0) scale(1); transform: translate3d(0, 0, 0) scale(1); }

  .fab-background { background: rgba(255, 255, 255, 0.97); width: 100%; height: 100%; position: fixed; top: 0; left: 0; z-index: 100; }
</style>



// WEBPACK FOOTER //
// DetalhesFAB.vue?208dd344